import * as GUI from 'babylonjs-gui';
//import * as BABYLON from 'babylonjs';
export default class GuiManager{
    constructor(game){
        this.scene=game.scene;
        this.canvas=game.canvas;
        this.advancedTexture =new GUI.AdvancedDynamicTexture.CreateFullscreenUI("ui1");
        this.text=this.initDistanceUI();
    }
    initDistanceUI(){
        let text = new GUI.TextBlock();
        text.text = "";
        text.color = "black";
        text.fontSize = 24;
        //text.paddingTop="50px"
        text.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        text.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        this.advancedTexture.addControl(text);
        return text;
    }
    refreshDistanceUI(distance){
        this.text.text ="长度:"+distance+"m";
    }
    cameraFOVslider(camera){
        let panel = new GUI.StackPanel();
        panel.width = "50px";
        panel.height="700px";
        panel.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        panel.verticalAlignment=GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        this.advancedTexture.addControl(panel);
        let camMoveOb;

        let MoveHeader = this.createHeader("移动");
        panel.addControl(MoveHeader);

        let b3 = this.createButton("but3","↑");
        
        b3.onPointerDownObservable.add(()=>{
            camMoveOb = this.scene.onBeforeRenderObservable.add(()=>{
                let newPos = camera.target;
                newPos.y-=1.0;
            });
        });
        b3.onPointerUpObservable.add(()=>{
            this.scene.onBeforeRenderObservable.remove(camMoveOb);
        });
        panel.addControl(b3);

        let b4 = this.createButton("but3","↓"); 
        b4.onPointerDownObservable.add(()=>{
            camMoveOb = this.scene.onBeforeRenderObservable.add(()=>{
                let newPos = camera.target;
                newPos.y+=1.0;
            });
        });
        b4.onPointerUpObservable.add(()=>{
            this.scene.onBeforeRenderObservable.remove(camMoveOb);
        });
        panel.addControl(b4);

        let b1 = this.createButton("but1","←");
       
        b1.onPointerDownObservable.add(()=>{
            camMoveOb = this.scene.onBeforeRenderObservable.add(()=>{
                let newPos = camera.target;
                newPos.x+=1.0;
            });
        });
        b1.onPointerUpObservable.add(()=>{
            this.scene.onBeforeRenderObservable.remove(camMoveOb);
        });
        panel.addControl(b1);

        let b2 = this.createButton("but2","→");
        
        b2.onPointerDownObservable.add(()=>{
            camMoveOb = this.scene.onBeforeRenderObservable.add(()=>{
                let newPos = camera.target;
                newPos.x-=1.0;
            });
        });
        b2.onPointerUpObservable.add(()=>{
            this.scene.onBeforeRenderObservable.remove(camMoveOb);
        });
        panel.addControl(b2);


        let FOVheader = this.createHeader("缩放");
        panel.addControl(FOVheader);

        let FOVslider = this.createSlider();
        FOVslider.minimum = 0.1;
        FOVslider.maximum = 2.5;
        panel.addControl(FOVslider);
        FOVslider.onValueChangedObservable.add(function(value) {
            camera.fov=value;
        });

        let AlphaHeader = this.createHeader("旋转");
        panel.addControl(AlphaHeader);

        let AlphaSlider = this.createSlider();
        AlphaSlider.minimum = 0;
        AlphaSlider.maximum = 2 * Math.PI;
        panel.addControl(AlphaSlider);
        AlphaSlider.onValueChangedObservable.add(function(value) {
            camera.alpha=(value);
        });

    }
    
    initGuiLine(name,alpha,width,color){
        let line = new GUI.Line(name);
        line.alpha = alpha;
        line.lineWidth = width;
        line.color=color;
        this.advancedTexture.addControl(line);
        return line;
    }
    initGuiTarget(name,width,height,bgColor,color){
        let target = new GUI.Ellipse(name);
        target.width = width;
        target.background = bgColor;
        target.height = height;
        target.color = color;
        this.advancedTexture.addControl(target);
        return target;
    }
    createLabel(mesh,height,width) {
        let label = new GUI.Rectangle("label for " + mesh.name);
        label.background = "black"
        label.height = height;
        label.alpha = 0.5;
        label.width = width;
        label.cornerRadius = 20;
        label.thickness = 1;
        label.linkOffsetY = 30;
        this.advancedTexture.addControl(label); 
        label.linkWithMesh(mesh);

        let text1 = new GUI.TextBlock();
        text1.text = mesh.name;
        text1.color = "white";
        label.addControl(text1);  
    }  
    createHeader(text){
        let header = new GUI.TextBlock();
        header.text = text;
        header.height = "40px";
        header.color = "#000000";
        header.textHorizontalAlignment = GUI.Control._HORIZONTAL_ALIGNMENT_CENTER;
        header.paddingTop = "10px";
        return header;
    }
    createSlider(){
        let slider = new GUI.Slider();
        slider.minimum = 0.2;
        slider.maximum = 1;
        slider.color = "#e1e1e1";
        slider.background="#e1e1e1";
        slider.borderColor="#4e4e4e"
        slider.thumbWidth="10px";
        slider.value = 0;
        slider.height = "200px";
        slider.width = "20px";
        slider.isVertical=true;
        return slider;
    }
    createButton(name,text){
        let button1 = GUI.Button.CreateSimpleButton(name, text);
        button1.width = "40px";
        button1.height = "40px";
        button1.color = "4e4e4e";
        button1.cornerRadius = 5;
        button1.background = "#e1e1e1";
        return button1;
    }
    createLabelAtPlane(mesh, text, fontSize) {
        let advancedTexture2 = GUI.AdvancedDynamicTexture.CreateForMesh(mesh);
        let textblock = new GUI.TextBlock();
        //textblock.height = "150px";
        textblock.fontSize = fontSize;
        textblock.text = text;
        advancedTexture2.addControl(textblock);
    }
    initAnimationCtrlPanel(meshes, animLengthes) {
        let animationCtrlPanel = new GUI.StackPanel();
        animationCtrlPanel.isVertical = false;
        animationCtrlPanel.width = "300px";
        animationCtrlPanel.height = "100px";
        animationCtrlPanel.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        animationCtrlPanel.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        this.advancedTexture.addControl(animationCtrlPanel);

        let slower = this.createButton("slower", "<<X2");
        slower.width = "60px";
        let play = this.createButton("play", "播放");
        let pause = this.createButton("pause", "暂停");
        let faster = this.createButton("faster", ">>X2");
        faster.width = "60px";
        let restart = this.createButton("restart", "重置");

        animationCtrlPanel.addControl(restart);
        animationCtrlPanel.addControl(slower);
        animationCtrlPanel.addControl(play);
        animationCtrlPanel.addControl(pause);
        animationCtrlPanel.addControl(faster);

        let animationCtrlPanel2 = new GUI.StackPanel();
        animationCtrlPanel2.isVertical = false;
        animationCtrlPanel2.width = "400px";
        animationCtrlPanel2.height = "30px";
        animationCtrlPanel2.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        animationCtrlPanel2.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        this.advancedTexture.addControl(animationCtrlPanel2);
        let text = new GUI.TextBlock();
        text.text = "视角不合适请手动操作右则[旋转][缩放]滑块";
        text.color = "black";
        text.fontSize = 20;
        animationCtrlPanel2.addControl(text);

        let firstplay = true;

        let animations = [];
        play.onPointerDownObservable.add(() => {
            if (firstplay) {
                for (let i = 0; i < meshes.length; i++) {
                    let anim = this.scene.beginAnimation(meshes[i], 0, animLengthes[i], true);
                    animations.push(anim);
                }
                firstplay = false;
            }
            else {
                for (let i = 0; i < animations.length; i++) {
                    animations[i].restart();
                }
            }

        });
        pause.onPointerDownObservable.add(() => {
            if (firstplay === false) {
                for (let i = 0; i < animations.length; i++) {
                    animations[i].pause();
                }
            }
        });
        faster.onPointerDownObservable.add(() => {
            if (firstplay === false) {
                for (let i = 0; i < animations.length; i++) {
                    animations[i].speedRatio *= 2;
                }
            }
        });
        restart.onPointerDownObservable.add(() => {
            if (firstplay === false) {
                for (let i = 0; i < animations.length; i++) {
                    animations[i].reset();
                }
            }
        });
        slower.onPointerDownObservable.add(() => {
            if (firstplay === false) {
                for (let i = 0; i < animations.length; i++) {
                    animations[i].speedRatio /= 2;
                }
            }
        });
    }
    gridCheckBox(grid){
        let checkbox = new GUI.Checkbox();
        checkbox.width = "20px";
        checkbox.height = "20px";
        checkbox.isChecked = true;
        checkbox.color = "green";
        checkbox.onIsCheckedChangedObservable.add(()=>{
            grid();
        });
        this.advancedTexture.addControl(checkbox);
    }
}